import { jsx as j } from "react/jsx-runtime";
import { useMergeRefs as p } from "@floating-ui/react";
import { forwardRef as u, isValidElement as R, cloneElement as g } from "react";
import { useTooltipContext as x } from "../hooks/useTooltipContext.js";
const y = u(({ children: e, asChild: a, openedTooltipClassName: t, ...s }, c) => {
  const { refs: n, open: r, getReferenceProps: o } = x(), i = e.ref, f = p([n.setReference, c, i]), m = r ? "open" : "closed";
  return a && R(e) ? g(
    e,
    o({
      ref: f,
      ...s,
      ...e.props,
      className: `${r && t ? t : ""} ${e.props.className} `,
      "data-state": m
    })
  ) : /* @__PURE__ */ j(
    "div",
    {
      ref: f,
      className: `jm-flex jm-cursor-pointer jm-items-center jm-justify-center ${r && t ? t : ""}`,
      "data-state": m,
      ...o(s),
      children: e
    }
  );
});
export {
  y as Trigger
};
//# sourceMappingURL=Trigger.js.map
